import React, { useState } from "react";

//carousel
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
//firebase
import { useData } from "../../../components/firebase/DataProvider";
//router
import { useHistory } from "react-router";
//style
import useStyles from "./style/style";
import { Skeleton } from "@material-ui/lab";
import slugify from "slugify";
import { useMediaQuery, useTheme } from "@material-ui/core";

function Swiper({ item }) {
  const classes = useStyles();

  const history = useHistory();

  const { slider } = useData();

  // seceleton
  const [load, setLoad] = useState(true);
  setTimeout(() => {
    setLoad(false);
  }, 1000);

  const handleAction = async (_, { props: { item } }) => {
    // console.log(item)
    switch (item.target_type) {
      case "kategori1":
      case "kategori2":
      case "kategori3":
      case "brand":
        history.push(
          `/kategori/${item.target_type}/${item.target_nama}/${item.target_id}`
        );
        break;
      case "promo":
        break;
      case "produk":
        history.push(
          `${item.target_type}/${slugify(item.target_nama.toLowerCase())}/${
            item.target_id
          }`
        );
        break;
      case "webview":
        window.open(`${item.target_id}`);
        break;
      default:
        break;
    }
  };

  const indicatorStyles = {
    background: "#fff",
    width: 10,
    height: 2,
    display: "inline-block",
    margin: "9px 6px",
    borderRadius: "0%",
    cursor: "pointer",
  };
  const indicatorSelectStyles = {
    width: 8,
    height: 8,
    display: "inline-block",
    margin: "6px 8px",
    borderRadius: "50%",
    border: "2px solid #fff",
    cursor: "pointer",
  };

  return (
    <div className={classes.carousel}>
      <Carousel
        showArrows={false}
        showThumbs={false}
        emulateTouch={true}
        infiniteLoop={true}
        showStatus={false}
        autoPlay={true}
        onClickItem={handleAction}
        renderIndicator={(onClickHandler, isSelected, index, label) => {
          if (isSelected) {
            return (
              <li
                style={{ ...indicatorSelectStyles }}
                aria-label={`Selected: ${label} ${index + 1}`}
                title={`Selected: ${label} ${index + 1}`}
              />
            );
          }
          return (
            <li
              style={indicatorStyles}
              onClick={onClickHandler}
              onKeyDown={onClickHandler}
              value={index}
              key={index}
              role="button"
              tabIndex={0}
              title={`${label} ${index + 1}`}
              aria-label={`${label} ${index + 1}`}
            />
          );
        }}
      >
        {load ? (
          <Skeleton
            variant="rect"
            style={{
              width: "100%",
              height: 350,
            }}
          />
        ) : (
          slider.map((item, index) => {
            return (
              <div key={index} item={item}>
                <img className={classes.hero} src={item.url} alt="hero" />
              </div>
            );
          })
        )}
      </Carousel>
    </div>
  );
}

// className={classes.hero} className={classes.carousel}

export default Swiper;
